import { List } from "immutable";
import _ from "lodash";
import * as React from "react";
import * as Comp from "../../../components";
import { ComponentWithValidatedForm } from "../../../components/validation";
import * as Forms from "../../../forms";
import * as M from "../../../models";
import { Api } from "../../../services/Api";

interface OwnProps {
    api: Api;
    cancelLink: JSX.Element;
    types: List<M.Email.EmailTemplateType>;
    onSubmit: (model: Forms.AdminEmailTemplate.TemplateData, body: any) => void;
}

interface OwnState {
}

export class EditForm extends ComponentWithValidatedForm<OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);
        const formModel = new Forms.AdminEmailTemplate.Template();
        this.state = {
            ...this.getInitialState(formModel),
        };
    }

    public setFormData(data: M.Email.EmailTemplate) {
        const formModel = this.getFormModelData<Forms.AdminEmailTemplate.TemplateData>();
        formModel.body = data.body;
        formModel.description = data.description;
        formModel.id = data.id;
        formModel.name = data.name;
        formModel.subject = data.subject;
        formModel.typeId = data.typeId;

        this.updateFormModelData(formModel);
    }

    public render() {
        const types: M.Editors.SelectItem[] = this.props.types
            .map((x: M.Email.EmailTemplateType) => ({
                id: x.id,
                render: x.name,
            }))
            .toArray();

        const formModel = this.getFormModelData<Forms.AdminEmailTemplate.TemplateData>();
        const type = this.props.types.find((x) => x !== undefined && x.id === formModel.typeId);
        const bodyVars = type && type.variables.length
            ? <>
                <p>The following variables are permitted in the email template:</p>
                <ul>
                    {type.variables.map((v, i) => (<li key={i}>||{v.name}||</li>))}
                </ul>
            </>
            : null;

        return <Comp.Validation.ValidatedForm
            formComponent={this}
            model={this.state.formModel.data}
            onValidSubmit={async (model) => this.handleSubmit(model)}
            schema={this.state.formModel.rules}
            ref={(ref: any) => this.form = ref}
        >

            <Comp.Editors.TextField formComponent={this} name="name" />
            <Comp.Editors.DropdownField formComponent={this} name="typeId" items={types} placeholder="Select" />
            <Comp.Editors.TextField formComponent={this} name="subject" />
            <Comp.Editors.TextAreaField formComponent={this} name="description" />
            <Comp.Editors.RichTextField formComponent={this} description={bodyVars} isAdmin name="body" />

            <Comp.Editors.SubmitField cancelLink={this.props.cancelLink} label="Save" showProcessing={this.state.formProcessing} />

        </Comp.Validation.ValidatedForm>;
    }

    private handleSubmit(model: Forms.AdminEmailTemplate.TemplateData) {
        const body = {
            body: model.body,
            description: model.description,
            id: model.id,
            name: model.name,
            subject: model.subject,
            typeId: model.typeId,
        };

        this.props.onSubmit(model, body);
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminEmailTemplates/edit/EditForm.tsx